// UI translations for each app language variant
// Language is now set at runtime via localStorage, not build-time env var

const translations = {
  amharic: {
    // 30-day free trial. Added 2026-10-26. ETHIOPIC AWAITING OWNER REVIEW.
    trialInviteTitle: 'ሁሉንም 348 የቅዳሴ ትምህርቶች ይክፈቱ',
    trialInviteDesc: 'ነጻ መለያ ይክፈቱ እና ለ30 ቀናት ሙሉ መዳረሻ ያግኙ። የክፍያ ካርድ አያስፈልግም።',
    trialStart: 'የ30 ቀን ነጻ ሙከራ ይጀምሩ',
    trialStarting: 'በመጀመር ላይ…',
    trialBadge: 'ነጻ ሙከራ',
    trialDaysRemaining: 'ቀናት ቀርተዋል',
    trialLastDay: 'ነጻ ሙከራ — የመጨረሻው ቀን',
    trialUsed: 'የነጻ ሙከራዎን ተጠቅመዋል። ነጻ ትምህርቶቹ ክፍት ሆነው ይቀጥላሉ።',
    premiumActive: 'ንቁ',
    lessonLocked: 'የተቆለፈ ትምህርት',
    // Teacher redeem codes (lifetime access). Added 2026-10-24.
    teacherCodeLink: 'የመምህር ኮድ አለዎት?',
    teacherCodeLabel: 'የመምህር ኮድዎን ያስገቡ',
    teacherCodeSubmit: 'ኮድ ይጠቀሙ',
    teacherCodeWorking: 'በማረጋገጥ ላይ…',
    teacherCodeCancel: 'ይመለሱ',
    teacherCodeSignIn: 'ኮድዎን ከማስገባት በፊት ይግቡ። መፍቀዱ ከመለያዎ ጋር ይያያዛል።',
    teacherLifetimeTitle: 'የዕድሜ ልክ የመምህር መፍቀድ',
    teacherLifetimeDesc: 'ሙሉ መዳረሻ አለዎት። ምንም የሚታደስ ነገር የለም።',
    teacherAlsoPaying: 'አሁንም የሚከፈልበት ምዝገባ አለዎት። የመምህር መፍቀዱ ምዝገባውን አያቆመውም፤ እራስዎ በመለያዎ ውስጥ እስኪሰርዙት ድረስ ክፍያው ይቀጥላል።',
    role_all: "ሁሉም",
    role_priest: "ካህን",
    role_asstpriest: "ረዳት ካህን",
    role_deacon: "ዲያቆን",
    role_people: "ሕዝብ",
    role_asstdeacon: "ረዳት ዲያቆን",
    role_together: "በአንድነት",
    browseAccount: "መለያ",
    browseVoices: "ተሳታፊዎች",
    browsePrayer: "የመክፈቻ ጸሎት",
    browseEyebrow: "የቅዳሴ ትምህርት",
    browseTitle: "ቅዳሴ ይማሩ",
    browseGuide: "መመሪያ",
    browseSettings: "ቅንብሮች",
    browseContinue: "ትምህርት ይቀጥሉ",
    browseLessons: "ትምህርቶች",
    browseBack: "ወደ ትምህርቶች",
    browseSearch: "ትምህርት ፈልግ",
    browseCompleted: "ተጠናቋል",
    browseListen: "ያዳምጡ እና ይለማመዱ",
    browseNoResults: "ትምህርት አልተገኘም",
    browseReader: "የትምህርት ጽሑፍ",
    browseChoose: "ትምህርት ይምረጡ",
    browseChooseHint: "ለመጀመር ከዝርዝሩ ትምህርት ይምረጡ።",
    // Header
    headerTitle: 'ሥርዓተ ቅዳሴ',
    headerSubtitle: 'የቅዳሴ ትምህርት',
    // Welcome screen
    welcomeTitle: 'ሥርዓተ ቅዳሴ ትምህርት',
    welcomeSubtitle: 'ቅዳሴ ይማሩ',
    welcomeFeature1: 'ትክክለኛ ዝማሬ ያዳምጡ',
    welcomeFeature2: 'ቃል በቃል ይከታተሉ',
    welcomeFeature3: 'ድምጽዎን ይቅዱ እና ይለማመዱ',
    welcomeEnter: 'ትምህርት ጀምር',
    welcomeVersion: 'ቅድመ-ልቀት 1.0',
    // Categories
    categoriesTitle: 'ምድቦች',
    categoryGeez: 'ግዕዝ',
    categoryEzli: 'ዕዝል',
    // Category group names
    sirateKidase: 'ሥርዓተ ቅዳሴ',
    kidaseHawariat: 'ቅዳሴ ሐዋርያት',
    chantsCount: 'ዝማሬዎች',
    // Lesson nav
    backToCategories: 'ወደ ምድቦች ተመለስ',
    previousLesson: 'ቀድሞ ያለው',
    nextLesson: 'ቀጣይ',
    // Subscription
    unlockTitle: 'ሁሉንም ትምህርቶች ክፈት',
    unlockDesc: 'ከሁሉም ምድቦች ጋር ሙሉ ተደራሽነት ያግኙ',
    unlockFeature1: 'ሥርዓተ ቅዳሴ (ግዕዝ እና ዕዝል)',
    unlockFeature2: 'ቅዳሴ ሐዋርያት (ግዕዝ እና ዕዝል)',
    unlockFeature3: 'ድምጽ ማጫወት እና ልምምድ',
    unlockFeature4: 'ድምጽ መቅዳት እና ማነጻጸር',
    signInToSubscribe: 'ለመመዝገብ ይግቡ',
    subscribeToUnlock: "Premium ያስፈልጋል",
    signInToUnlock: "የ Premium ትምህርት — ይግቡ",
    signInTitle: "ይህ ትምህርት Premium ይፈልጋል",
    signInDesc: "ይህን ትምህርት ለመክፈት Kidase Premium ያስፈልጋል።",
    signInFeature1: "በእያንዳንዱ ምድብ የመጀመሪያዎቹ 7 ትምህርቶች ነጻ ናቸው።",
    signInFeature2: "Premium የቀሩትን ትምህርቶች ይከፍታል።",
    signInFeature3: "በ Google መግባት ብቻ Premium አያስገኝም።",
    signInCta: "በ Google ይግቡ",
    close: "ዝጋ",
    premiumAccountNotice: "መለያዎ በአሁኑ ጊዜ Premium መዳረሻ የለውም።",
    continueFree: "ነጻ ትምህርቶችን ይቀጥሉ",
    billingTest: "የክፍያ ሙከራ — እውነተኛ ክፍያ አይወሰድም",
    billingChoose: "የምዝገባ ዕቅድ ይምረጡ",
    billingAnnual: "ዓመታዊ",
    billingMonthly: "ወርሃዊ",
    billingYear: "ዓመት",
    billingMonth: "ወር",
    billingTerms: "ምዝገባው እስኪሰረዝ ድረስ በራስ-ሰር ይታደሳል። በማንኛውም ጊዜ መሰረዝ ይችላሉ፤ መዳረሻዎ እስከተከፈለበት ጊዜ መጨረሻ ይቀጥላል። የዓመት ክፍያ በአንድ ጊዜ ይከፈላል። ተፈጻሚ ግብሮች በክፍያ ገጹ ይታያሉ።",
    billingLoading: "ዕቅዶችን በመጫን ላይ…",
    billingUnavailable: "ምዝገባ ለጊዜው አይገኝም። ነጻ ትምህርቶችን ይቀጥሉ።",
    billingConnecting: "በማገናኘት ላይ…",
    billingCheckout: "ወደ ደህንነቱ የተጠበቀ ክፍያ ይቀጥሉ",
    billingSignInCheckout: "ይግቡ እና ወደ ክፍያ ይቀጥሉ",
    billingExisting: "ቀድሞ ተመዝግበዋል? ይግቡ",
    billingCanceled: "ክፍያ አልተጠናቀቀም። ነጻ ትምህርቶችን መቀጠል ይችላሉ።",
    billingConfirming: "ምዝገባዎን በማረጋገጥ ላይ…",
    billingWaiting: "ምዝገባዎ ገና አልተረጋገጠም። እንደገና ያረጋግጡ።",
    subscriptionActivated: 'ምዝገባ ተነቃቃ! ሁሉም ትምህርቶች ተከፍተዋል።',
    // Auth
    signIn: 'ይግቡ',
    signOut: 'ይውጡ',
    upgrade: 'ያሻሽሉ',
    manage: 'ያስተዳድሩ',
    // Loading
    loading: 'ቅዳሴ በመጫን ላይ...',
    errorLoading: 'ስህተት፡',
    retry: 'እንደገና ሞክር',
    noData: 'የቅዳሴ መረጃ አልተገኘም።',
    // Bookmarks
    myBookmarks: 'ዕልባቶቼ',
    addBookmark: 'ዕልባት አድርግ',
    removeBookmark: 'ዕልባት አስወግድ',
    noBookmarks: 'ምንም ዕልባት የለም',
    // Feedback
    feedbackTitle: 'አስተያየት ይላኩ',
    feedbackRating: 'ደረጃ፡',
    feedbackPlaceholder: 'ምን ማሻሻል እንችላለን? ችግር ወይም ሃሳብ...',
    feedbackSend: 'አስተያየት ላክ',
    feedbackSending: 'በመላክ ላይ...',
    feedbackThanks: 'ለአስተያየትዎ እናመሰግናለን!',
    // Feedback categories
    feedbackCat_general: 'አጠቃላይ',
    feedbackCat_bug: 'ስህተት',
    feedbackCat_feature: 'ባህሪ',
    feedbackCat_content: 'ይዘት',
    // Admin
    adminTitle: 'አስተዳዳሪ',
    adminTab_overview: 'አጠቃላይ',
    adminTab_users: 'ተጠቃሚዎች',
    adminTab_feedback: 'አስተያየቶች',
    adminStatUsers: 'ጠቅላላ ተጠቃሚዎች',
    adminStatNewUsers: 'አዳዲስ (30 ቀን)',
    adminStatPremium: 'ፕሪሚየም',
    adminStatFeedback: 'ጠቅላላ አስተያየት',
    adminStatUnresolved: 'ያልተፈቱ',
    adminStatAvgRating: 'አማካይ ደረጃ',
    adminFilterAll: 'ሁሉም',
    adminFilterUnresolved: 'ያልተፈቱ',
    adminMarkResolved: 'ፍታ',
    adminResolved: 'ተፈትቷል',
    adminNoUsers: 'ተጠቃሚ አልተገኘም',
    adminNoFeedback: 'አስተያየት አልተገኘም',
    // AI Assistant
    aiAssistantTitle: 'የቅዳሴ ረዳት',
    aiPlaceholder: 'ስለ ዝማሬው ይጠይቁ...',
    aiRemaining: 'ጥያቄዎች ቀርተዋል',
    aiLimitReached: 'የዕለት ጥያቄ ገደብ ደርሷል',
    aiSignInRequired: 'ረዳቱን ለመጠቀም ይግቡ',
    aiWelcome: 'ስለዚህ ዝማሬ ይጠይቁኝ!',
    aiThinking: 'እያሰብኩ ነው...',
    aiUpgradeHint: 'ላልተገደበ ጥያቄ ያሻሽሉ።',
    // Language toggle
    langToggleNative: 'አማርኛ',
    langToggleLatin: 'Latin',
    // Language picker
    showText: 'ጽሑፍ አሳይ',
    langPickerTitle: 'ቋንቋ ይምረጡ',
    langAmharic: 'አማርኛ',
    langTigrinya: 'ትግርኛ',
    langLatin: 'English',
    // Premium lesson dialog (from the live billing line)
    premiumLessonTitle: 'ይህ ትምህርት የቅዳሴ ፕሪሚየም አካል ነው',
    premiumLessonDesc: 'በእያንዳንዱ ክፍል የመጀመሪያዎቹ 7 ትምህርቶች ነጻ ናቸው። Kidase Individual ሁሉንም ትምህርቶች ይከፍታል።',
    viewPlans: 'የምዝገባ ዕቅዶችን ይመልከቱ',
    alreadySubscribed: 'ተመዝግበዋል? ይግቡ',
    perMonth: 'ወር',
    perYear: 'ዓመት',
    or: 'ወይም',
  },

  tigrinya: {
    // 30-day free trial. Added 2026-10-26. ETHIOPIC AWAITING OWNER REVIEW.
    trialInviteTitle: 'ኩሎም 348 ትምህርትታት ቅዳሴ ክፈቱ',
    trialInviteDesc: 'ነጻ መለለዪ ክፈቱ፤ ን30 መዓልቲ ምሉእ መእተዊ ትረኽቡ። ናይ ክፍሊት ካርድ ኣየድልን።',
    trialStart: 'ናይ 30 መዓልቲ ነጻ ፈተነ ጀምሩ',
    trialStarting: 'ይጅምር ኣሎ…',
    trialBadge: 'ነጻ ፈተነ',
    trialDaysRemaining: 'መዓልትታት ተሪፉ',
    trialLastDay: 'ነጻ ፈተነ — ናይ መወዳእታ መዓልቲ',
    trialUsed: 'ነጻ ፈተነኹም ተጠቒምኩም። እቶም ነጻ ትምህርትታት ክፉታት ይቕጽሉ።',
    premiumActive: 'ንጡፍ',
    lessonLocked: 'ዝተዓጽወ ትምህርቲ',
    // Teacher redeem codes (lifetime access). Added 2026-10-24.
    teacherCodeLink: 'ኮድ መምህር ኣሎኩም ድዩ?',
    teacherCodeLabel: 'ኮድ መምህርኩም ኣእትዉ',
    teacherCodeSubmit: 'ኮድ ተጠቐሙ',
    teacherCodeWorking: 'ይረጋገጽ ኣሎ…',
    teacherCodeCancel: 'ተመለሱ',
    teacherCodeSignIn: 'ኮድኩም ቅድሚ ምእታው ይእተዉ። እቲ መፍቀዲ ምስ መለለዪኹም ይተኣሳሰር።',
    teacherLifetimeTitle: 'ናይ ዕድመ ልክዕ መፍቀዲ መምህር',
    teacherLifetimeDesc: 'ምሉእ መእተዊ ኣሎኩም። ዝሕደስ ነገር የለን።',
    teacherAlsoPaying: 'ክፍሊት ዝኽፈሎ ምዝገባ ኣሎኩም። እቲ ናይ መምህር መፍቀዲ ነቲ ምዝገባ ኣየቋርጾን፤ ባዕልኹም ኣብ መለለዪኹም ክሳብ እትስርዝዎ ክፍሊት ይቕጽል።',
    role_all: "ኩሎም",
    role_priest: "ካህን",
    role_asstpriest: "ሓጋዚ ካህን",
    role_deacon: "ዲያቆን",
    role_people: "ህዝቢ",
    role_asstdeacon: "ሓጋዚ ዲያቆን",
    role_together: "ብሓባር",
    browseAccount: "መለለዪ",
    browseVoices: "ተሳተፍቲ",
    browsePrayer: "ናይ መኽፈቲ ጸሎት",
    browseEyebrow: "ትምህርቲ ቅዳሴ",
    browseTitle: "ቅዳሴ ተማሃሩ",
    browseGuide: "መምርሒ",
    browseSettings: "ቅጥዕታት",
    browseContinue: "ትምህርቲ ቀጽሉ",
    browseLessons: "ትምህርትታት",
    browseBack: "ናብ ትምህርትታት",
    browseSearch: "ትምህርቲ ድለዩ",
    browseCompleted: "ተዛዚሙ",
    browseListen: "ስምዑን ተለማመዱን",
    browseNoResults: "ትምህርቲ ኣይተረኽበን",
    browseReader: "ጽሑፍ ትምህርቲ",
    browseChoose: "ትምህርቲ ምረጹ",
    browseChooseHint: "ንምጅማር ካብ ዝርዝር ትምህርቲ ምረጹ።",
    headerTitle: 'ሥርዓተ ቅዳሴ',
    headerSubtitle: 'ትምህርቲ ቅዳሴ',
    welcomeTitle: 'ሥርዓተ ቅዳሴ ትምህርቲ',
    welcomeSubtitle: 'ቅዳሴ ተማሃሩ',
    welcomeFeature1: 'ሓቀኛ ዝማረ ስምዑ',
    welcomeFeature2: 'ቃል ብቓል ተኸታተሉ',
    welcomeFeature3: 'ድምጽኹም ቅረጹ ተለማመዱ',
    welcomeEnter: 'ትምህርቲ ጀምር',
    welcomeVersion: 'ቅድመ-ልቀት 1.0',
    categoriesTitle: 'ምድባት',
    categoryGeez: 'ግዕዝ',
    categoryEzli: 'ዕዝል',
    sirateKidase: 'ሥርዓተ ቅዳሴ',
    kidaseHawariat: 'ቅዳሴ ሐዋርያት',
    chantsCount: 'ዝማረታት',
    backToCategories: 'ናብ ምድባት ተመለስ',
    previousLesson: 'ዝሓለፈ',
    nextLesson: 'ዝቕጽል',
    unlockTitle: 'ኩሎም ትምህርትታት ክፈት',
    unlockDesc: 'ናይ ኩሎም ምድባት ሙሉእ ተበጻሕነት ረኸቡ',
    unlockFeature1: 'ሥርዓተ ቅዳሴ (ግዕዝን ዕዝልን)',
    unlockFeature2: 'ቅዳሴ ሐዋርያት (ግዕዝን ዕዝልን)',
    unlockFeature3: 'ድምጺ ምጽዋት ልምምድ',
    unlockFeature4: 'ድምጺ ምቕራጽ ምንጽጻር',
    signInToSubscribe: 'ንምምዝጋብ ስለ ዝኣቱ',
    subscribeToUnlock: "Premium የድሊ",
    signInToUnlock: "ናይ Premium ትምህርቲ — ይእተዉ",
    signInTitle: "እዚ ትምህርቲ Premium የድልዮ",
    signInDesc: "ነዚ ትምህርቲ ንምኽፋት Kidase Premium የድሊ።",
    signInFeature1: "ኣብ ነፍሲ ወከፍ ምድብ እቶም ቀዳሞት 7 ትምህርትታት ነጻ እዮም።",
    signInFeature2: "Premium ነቶም ዝተረፉ ትምህርትታት ይኸፍት።",
    signInFeature3: "ብ Google ምእታው ጥራይ Premium ኣይህብን።",
    signInCta: "ብ Google ይእተዉ",
    close: "ዕጸዉ",
    premiumAccountNotice: "መለለዪኹም ኣብዚ እዋን Premium መዳረሻ የብሉን።",
    continueFree: "ነጻ ትምህርትታት ቀጽሉ",
    billingTest: "ናይ ክፍሊት ፈተነ — ናይ ሓቂ ክፍሊት ኣይውሰድን",
    billingChoose: "ናይ ምዝገባ መደብ ምረጹ",
    billingAnnual: "ዓመታዊ",
    billingMonthly: "ወርሓዊ",
    billingYear: "ዓመት",
    billingMonth: "ወርሒ",
    billingTerms: "ምዝገባኹም ክሳብ ዝስረዝ ብርእሱ ይሕደስ። ኣብ ዝደለኹሞ ግዜ ክትስርዙ ትኽእሉ፤ መዳረሻኹም ክሳብ መወዳእታ እቲ ዝኸፈልኩምሉ ግዜ ይቕጽል። ናይ ዓመት ክፍሊት ብሓንሳብ ይኽፈል። ዝምልከቱ ግብርታት ኣብ ገጽ ክፍሊት ይርኣዩ።",
    billingLoading: "መደባት ይጽዕኑ ኣለዉ…",
    billingUnavailable: "ምዝገባ ንግዚኡ ኣይርከብን። ነጻ ትምህርትታት ቀጽሉ።",
    billingConnecting: "ይራኸብ ኣሎ…",
    billingCheckout: "ናብ ውሑስ ክፍሊት ቀጽሉ",
    billingSignInCheckout: "እተዉ ናብ ክፍሊት ቀጽሉ",
    billingExisting: "ተመዝጊብኩም ዲኹም? እተዉ",
    billingCanceled: "ክፍሊት ኣይተዛዘመን። ነጻ ትምህርትታት ክትቅጽሉ ትኽእሉ።",
    billingConfirming: "ምዝገባኹም ነረጋግጽ ኣለና…",
    billingWaiting: "ምዝገባኹም ገና ኣይተረጋገጸን። ደጊምኩም ኣረጋግጹ።",
    subscriptionActivated: 'ምዝገባ ተነቃቂሑ! ኩሎም ትምህርትታት ተኸፊቶም።',
    signIn: 'እተዉ',
    signOut: 'ውጻእ',
    upgrade: 'ኣሻሽል',
    manage: 'ኣመሓድር',
    loading: 'ቅዳሴ ይጽዓን ኣሎ...',
    errorLoading: 'ጌጋ፡',
    retry: 'ደጊምካ ፈትን',
    noData: 'ናይ ቅዳሴ ሓበሬታ ኣይተረኽበን።',
    // Bookmarks
    myBookmarks: 'ዕልባታተይ',
    addBookmark: 'ዕልባት ግበር',
    removeBookmark: 'ዕልባት ኣውጽእ',
    noBookmarks: 'ዕልባት የለን',
    feedbackTitle: 'ርእይቶ ስደዱ',
    feedbackRating: 'ደረጃ፡',
    feedbackPlaceholder: 'እንታይ ከነማሓይሽ? ጸገም ወይ ሓሳብ...',
    feedbackSend: 'ርእይቶ ስደድ',
    feedbackSending: 'ይልኣኽ ኣሎ...',
    feedbackThanks: 'ንርእይቶኹም ነመስግን!',
    // Feedback categories
    feedbackCat_general: 'ሓፈሻዊ',
    feedbackCat_bug: 'ጌጋ',
    feedbackCat_feature: 'ባህሪ',
    feedbackCat_content: 'ትሕዝቶ',
    // Admin
    adminTitle: 'ኣመሓዳሪ',
    adminTab_overview: 'ሓፈሻዊ',
    adminTab_users: 'ተጠቀምቲ',
    adminTab_feedback: 'ርእይቶታት',
    adminStatUsers: 'ጠቕላላ ተጠቀምቲ',
    adminStatNewUsers: 'ሓደስቲ (30 መዓልቲ)',
    adminStatPremium: 'ፕሪሚየም',
    adminStatFeedback: 'ጠቕላላ ርእይቶ',
    adminStatUnresolved: 'ዘይተፈትሑ',
    adminStatAvgRating: 'ማእከላይ ደረጃ',
    adminFilterAll: 'ኩሉ',
    adminFilterUnresolved: 'ዘይተፈትሑ',
    adminMarkResolved: 'ፍታሕ',
    adminResolved: 'ተፈቲሑ',
    adminNoUsers: 'ተጠቃሚ ኣይተረኽበን',
    adminNoFeedback: 'ርእይቶ ኣይተረኽበን',
    // AI Assistant
    aiAssistantTitle: 'ናይ ቅዳሴ ረዳኢ',
    aiPlaceholder: 'ብዛዕባ ዝማረ ሕተቱ...',
    aiRemaining: 'ሕቶታት ተሪፈን',
    aiLimitReached: 'ናይ መዓልቲ ሕቶ ገደብ በጺሑ',
    aiSignInRequired: 'ረዳኢ ንምጥቃም እቶ',
    aiWelcome: 'ብዛዕባ እዚ ዝማረ ሕተቱኒ!',
    aiThinking: 'ይሓስብ ኣሎ...',
    aiUpgradeHint: 'ንዘይተገደበ ሕቶ ኣሻሽሉ።',
    langToggleNative: 'ትግርኛ',
    langToggleLatin: 'Latin',
    // Language picker
    showText: 'ጽሑፍ ኣርኢ',
    langPickerTitle: 'ቋንቋ ምረጹ',
    langAmharic: 'አማርኛ',
    langTigrinya: 'ትግርኛ',
    langLatin: 'English',
    // Premium lesson dialog (from the live billing line)
    premiumLessonTitle: 'እዚ ትምህርቲ ኣካል ቅዳሴ ፕሪሚየም እዩ',
    premiumLessonDesc: 'ኣብ ነፍሲ ወከፍ ክፍሊ እተን ቀዳሞት 7 ትምህርትታት ነጻ እየን። Kidase Individual ንኹሎም ትምህርትታት ይኸፍት።',
    viewPlans: 'መደባት ምዝገባ ርኣዩ',
    alreadySubscribed: 'ተመዝጊብኩም ዲኹም? ይእተዉ',
    perMonth: 'ወርሒ',
    perYear: 'ዓመት',
    or: 'ወይ',
  },

  latin: {
    // 30-day free trial. Added 2026-10-26. ETHIOPIC AWAITING OWNER REVIEW.
    trialInviteTitle: 'Unlock All 348 Kidase Lessons',
    trialInviteDesc: 'Create a free account and enjoy 30 days of complete access. No credit card required.',
    trialStart: 'Start 30-Day Free Trial',
    trialStarting: 'Starting…',
    trialBadge: 'Free Trial',
    trialDaysRemaining: 'days remaining',
    trialLastDay: 'Free Trial — last day',
    trialUsed: 'You have used your free trial. The free lessons stay open to you.',
    premiumActive: 'Active',
    lessonLocked: 'Locked lesson',
    // Teacher redeem codes (lifetime access). Added 2026-10-24.
    teacherCodeLink: 'Have a teacher code?',
    teacherCodeLabel: 'Enter your teacher code',
    teacherCodeSubmit: 'Use code',
    teacherCodeWorking: 'Checking…',
    teacherCodeCancel: 'Back',
    teacherCodeSignIn: 'Please sign in before entering your code. The access is attached to your account.',
    teacherLifetimeTitle: 'Lifetime Teacher Access',
    teacherLifetimeDesc: 'You have full access, for good. There is nothing to renew.',
    teacherAlsoPaying: 'You also have a paid subscription. Your teacher access does not stop it — it will keep billing until you cancel it yourself from your account.',
    role_all: "All",
    role_priest: "Priest",
    role_asstpriest: "Assistant priest",
    role_deacon: "Deacon",
    role_people: "Congregation",
    role_asstdeacon: "Assistant deacon",
    role_together: "Together",
    browseAccount: "Account",
    browseVoices: "Voices",
    browsePrayer: "Opening prayer",
    browseEyebrow: "LISTEN · LEARN · PRACTICE",
    browseTitle: "Learn Kidase",
    browseGuide: "Guide",
    browseSettings: "Settings",
    browseContinue: "Continue learning",
    browseLessons: "Lessons",
    browseBack: "Back to lessons",
    browseSearch: "Search lessons",
    browseCompleted: "Completed",
    browseListen: "Listen & practice",
    browseNoResults: "No matching lessons",
    browseReader: "Lesson reader",
    browseChoose: "Choose a lesson",
    browseChooseHint: "Select a lesson from the list to listen, read, and practice.",
    headerTitle: 'Sirate Kidase',
    headerSubtitle: 'Sirate Kidase Tutor',
    welcomeTitle: 'Sirate Kidase Tutor',
    welcomeSubtitle: 'Learn the Orthodox Divine Liturgy',
    welcomeFeature1: 'Listen to authentic chanting',
    welcomeFeature2: 'Follow along word by word',
    welcomeFeature3: 'Record and practice your voice',
    welcomeEnter: 'Begin Learning',
    welcomeVersion: 'Beta Version 1.0',
    categoriesTitle: 'Categories',
    categoryGeez: 'Geez',
    categoryEzli: 'Ezli',
    sirateKidase: 'Sirate Kidase',
    kidaseHawariat: 'Kidase Hawariat',
    chantsCount: 'chants',
    backToCategories: 'Back to categories',
    previousLesson: 'Previous lesson',
    nextLesson: 'Next lesson',
    unlockTitle: 'Unlock All Lessons',
    unlockDesc: 'Get full access to all chants across every category with audio playback and practice mode.',
    unlockFeature1: 'Sirate Kidase (Geez & Ezli)',
    unlockFeature2: 'Kidase Hawariat (Geez & Ezli)',
    unlockFeature3: 'Audio playback & practice mode',
    unlockFeature4: 'Voice recording & compare',
    signInToSubscribe: 'Sign in to subscribe',
    subscribeToUnlock: "Premium required",
    signInToUnlock: "Premium lesson — sign in",
    signInTitle: "This lesson requires Premium",
    signInDesc: "Access this lesson with Kidase Premium.",
    signInFeature1: "The first 7 lessons in each category are free.",
    signInFeature2: "Premium unlocks the remaining lessons.",
    signInFeature3: "Google sign-in alone does not include Premium.",
    signInCta: "Sign in with Google",
    close: "Close",
    premiumAccountNotice: "Your account does not currently have Premium access.",
    continueFree: "Continue with free lessons",
    billingTest: "Payment testing — no real charges",
    billingChoose: "Choose your plan",
    billingAnnual: "Annual",
    billingMonthly: "Monthly",
    billingYear: "year",
    billingMonth: "month",
    billingTerms: "Renews automatically until canceled. Cancel anytime; access continues until the end of your paid period. Annual plans are billed in full once a year. Any applicable tax is shown at checkout.",
    billingLoading: "Loading plans…",
    billingUnavailable: "Subscriptions are not available yet. Please continue with the free lessons.",
    billingConnecting: "Connecting…",
    billingCheckout: "Continue to secure checkout",
    billingSignInCheckout: "Sign in and continue to checkout",
    billingExisting: "Already subscribed? Sign in",
    billingCanceled: "Checkout was not completed. You can continue with the free lessons.",
    billingConfirming: "Confirming your subscription…",
    billingWaiting: "Your subscription is not confirmed yet. Check again shortly.",
    subscriptionActivated: 'Subscription activated! All lessons are now unlocked.',
    signIn: 'Sign in',
    signOut: 'Sign out',
    upgrade: 'Upgrade',
    manage: 'Manage',
    loading: 'Loading liturgy...',
    errorLoading: 'Error loading data:',
    retry: 'Retry',
    noData: 'No liturgy data found.',
    // Bookmarks
    myBookmarks: 'My Bookmarks',
    addBookmark: 'Add bookmark',
    removeBookmark: 'Remove bookmark',
    noBookmarks: 'No bookmarks yet',
    feedbackTitle: 'Send Feedback',
    feedbackRating: 'Rating:',
    feedbackPlaceholder: 'What can we improve? Any issues or suggestions...',
    feedbackSend: 'Send Feedback',
    feedbackSending: 'Sending...',
    feedbackThanks: 'Thank you for your feedback!',
    // Feedback categories
    feedbackCat_general: 'General',
    feedbackCat_bug: 'Bug',
    feedbackCat_feature: 'Feature',
    feedbackCat_content: 'Content',
    // Admin
    adminTitle: 'Admin Dashboard',
    adminTab_overview: 'Overview',
    adminTab_users: 'Users',
    adminTab_feedback: 'Feedback',
    adminStatUsers: 'Total Users',
    adminStatNewUsers: 'New (30 days)',
    adminStatPremium: 'Premium',
    adminStatFeedback: 'Total Feedback',
    adminStatUnresolved: 'Unresolved',
    adminStatAvgRating: 'Avg Rating',
    adminFilterAll: 'All',
    adminFilterUnresolved: 'Unresolved',
    adminMarkResolved: 'Mark Resolved',
    adminResolved: 'Resolved',
    adminNoUsers: 'No users found',
    adminNoFeedback: 'No feedback found',
    // AI Assistant
    aiAssistantTitle: 'Kidase Assistant',
    aiPlaceholder: 'Ask about this chant...',
    aiRemaining: 'questions left',
    aiLimitReached: 'Daily question limit reached',
    aiSignInRequired: 'Sign in to use the assistant',
    aiWelcome: 'Ask me about this chant!',
    aiThinking: 'Thinking...',
    aiUpgradeHint: 'Upgrade for unlimited questions.',
    langToggleNative: 'Latin',
    langToggleLatin: 'Latin',
    // Language picker
    showText: 'Show text',
    langPickerTitle: 'Choose Language',
    langAmharic: 'Amharic',
    langTigrinya: 'Tigrinya',
    langLatin: 'English',
    // Premium lesson dialog (from the live billing line)
    premiumLessonTitle: 'This lesson is part of Kidase Premium',
    premiumLessonDesc: 'The first 7 lessons in each section are free. Kidase Individual unlocks every lesson.',
    viewPlans: 'View Subscription Plans',
    alreadySubscribed: 'Already subscribed? Sign in',
    perMonth: 'month',
    perYear: 'year',
    or: 'or',
  }
}

// Mutable module-level language — read from localStorage, changeable at runtime
let _currentLanguage = localStorage.getItem('sk_app_language') || 'tigrinya'

export function getAppLanguage() {
  return _currentLanguage
}

export function setAppLanguage(lang) {
  _currentLanguage = lang
  localStorage.setItem('sk_app_language', lang)
}

// Translation functions — read _currentLanguage at call time (reactive)
export function t(key) {
  return translations[_currentLanguage]?.[key] || translations.latin[key] || key
}

// English tooltip — returns English translation for hover hints
// Returns undefined for the latin app (no tooltip needed)
export function tEn(key) {
  if (_currentLanguage === 'latin') return undefined
  return translations.latin[key]
}

// Dynamic getters for text field and toggle languages
export function getTextField() {
  return _currentLanguage === 'amharic' ? '_amharictext'
    : _currentLanguage === 'tigrinya' ? '_tigrinyatext'
    : '_latintext'
}

export function getToggleLanguages() {
  if (_currentLanguage === 'latin') {
    return [{ key: 'latin', field: '_latintext' }]
  }
  return [
    { key: _currentLanguage, field: getTextField() },
    { key: 'latin', field: '_latintext' }
  ]
}

export default translations
